"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdateInterstitialService = void 0;
const hooks_1 = require("../../hooks");
const useUpdateInterstitialService = (repository) => {
    const { call: updateInterstitialCall, isError: isUpdateInterstitialError, isLoading: isUpdateInterstitialLoading, isSuccess: isUpdateInterstitialSuccess, } = (0, hooks_1.useAsyncStateInfo)(repository.updateInterstitialToDismiss);
    return {
        updateInterstitialCall,
        isUpdateInterstitialError,
        isUpdateInterstitialLoading,
        isUpdateInterstitialSuccess,
    };
};
exports.useUpdateInterstitialService = useUpdateInterstitialService;
//# sourceMappingURL=useUpdateInterstitialService.hook.js.map